<div class="pacotes-page">

  <!-- ================================
       TOPO
  ================================ -->

  <div class="topbar">

    <div>

      <span class="topbar-label">
        GERENCIAMENTO
      </span>

      <h1>
        Pacotes adicionais
      </h1>

      <p>
        Cadastre experiências e serviços extras
        para oferecer aos hóspedes.
      </p>

    </div>

    <button
      type="button"
      class="btn-novo"
      (click)="novoPacote()"
    >
      <span>+</span>
      Novo pacote
    </button>

  </div>


  <!-- ================================
       MENSAGENS
  ================================ -->

  @if (mensagemSucesso) {

    <div class="mensagem sucesso">

      <span>
        ✓
      </span>

      <span>
        {{ mensagemSucesso }}
      </span>

      <button
        type="button"
        (click)="mensagemSucesso = ''"
      >
        ×
      </button>

    </div>

  }


  <!-- ================================
       SEÇÃO
  ================================ -->

  <section class="pacotes-section">

    <!-- LOADING -->

    @if (carregando) {

      <div class="loading">
        Carregando pacotes...
      </div>

    }


    <!-- ================================
         LISTAGEM
    ================================ -->

    @if (!carregando) {

      @if (pacotes.length === 0) {

        <div class="estado-vazio">

          <div class="vazio-icone">
            +
          </div>

          <h2>
            Nenhum pacote cadastrado
          </h2>

          <p>
            Comece cadastrando um pacote adicional
            para os hóspedes.
          </p>

          <button
            type="button"
            class="btn-novo"
            (click)="novoPacote()"
          >
            Cadastrar primeiro pacote
          </button>

        </div>

      } @else {

        <div class="pacotes-grid">

          @for (
            pacote of pacotes;
            track pacote.id
            ) {

            <article
              class="pacote-card"
              [class.inativo]="!pacote.ativo"
            >

              <!-- ================================
                   IMAGENS
              ================================ -->

              @if (
                pacote.imagens &&
                pacote.imagens.length > 0
                ) {

                <div class="pacote-imagens">

                  @for (
                    imagem of pacote.imagens.slice(0, 3);
                    track imagem.id
                    ) {

                    <div class="pacote-imagem">

                      <img
                        [src]="obterImagemUrl(imagem.url)"
                        [alt]="pacote.nome"
                      />

                    </div>

                  }

                  @if (pacote.imagens.length > 1) {

                    <span class="pacote-imagem-count">
                      {{ pacote.imagens.length }} imagens
                    </span>

                  }

                </div>

              } @else {

                <div class="pacote-sem-imagem">

                  <span>
                    📷
                  </span>

                  <small>
                    Sem imagem
                  </small>

                </div>

              }


              <!-- ================================
                   TOPO DO CARD
              ================================ -->

              <div class="pacote-topo">

                <div>

                  <span class="pacote-id">
                    #{{ pacote.id }}
                  </span>

                  <h3>
                    {{ pacote.nome }}
                  </h3>

                </div>

                <span
                  class="status"
                  [class.ativo]="pacote.ativo"
                  [class.inativo]="!pacote.ativo"
                >
                  {{ pacote.ativo ? 'Ativo' : 'Inativo' }}
                </span>

              </div>


              <!-- ================================
                   DESCRIÇÃO
              ================================ -->

              @if (pacote.descricao) {

                <div class="pacote-descricao">

                  <span>
                    DESCRIÇÃO
                  </span>

                  <strong>
                    {{ pacote.descricao }}
                  </strong>

                </div>

              }


              <!-- ================================
                   DADOS
              ================================ -->

              <div class="pacote-dados">

                <div class="pacote-dado">

                  <span>
                    ACOMODAÇÃO
                  </span>

                  <strong>
                    {{ pacote.acomodacao }}
                  </strong>

                </div>

                <div class="pacote-dado">

                  <span>
                    VALOR
                  </span>

                  <strong class="valor">
                    {{ formatarValor(pacote.valor) }}
                  </strong>

                </div>

              </div>


              <!-- ================================
                   ITENS INCLUSOS
              ================================ -->

              @if (pacote.itensInclusos) {

                <div class="pacote-itens">

                  <span class="pacote-itens-titulo">
                    O QUE ESTÁ INCLUSO
                  </span>

                  @for (
                    item of getItens(pacote.itensInclusos);
                    track $index
                    ) {

                    <div class="pacote-item">

                      <span>
                        ✓
                      </span>

                      <span>
                        {{ item }}
                      </span>

                    </div>

                  }

                </div>

              }


              <!-- ================================
                   AÇÕES
              ================================ -->

              <div class="pacote-acoes">

                <button
                  type="button"
                  class="btn-acao editar"
                  (click)="editarPacote(pacote)"
                >
                  Editar
                </button>

                <button
                  type="button"
                  class="btn-acao status-btn"
                  (click)="alterarStatus(pacote)"
                >
                  {{ pacote.ativo ? 'Desativar' : 'Ativar' }}
                </button>

                <button
                  type="button"
                  class="btn-acao excluir"
                  (click)="excluirPacote(pacote)"
                >
                  Excluir
                </button>

              </div>

            </article>

          }

        </div>

      }

    }

  </section>

</div>


<!-- ================================
     MODAL
================================ -->

@if (mostrarFormulario) {

  <div
    class="modal-overlay"
    (click)="fecharFormulario()"
  >

    <div
      class="modal"
      (click)="$event.stopPropagation()"
    >

      <!-- ================================
           CABEÇALHO
      ================================ -->

      <div class="modal-header">

        <div>

          <h2>
            {{
              editando
                ? 'Editar pacote'
                : 'Novo pacote'
            }}
          </h2>

        </div>

        <button
          type="button"
          class="fechar"
          (click)="fecharFormulario()"
        >
          ×
        </button>

      </div>


      <!-- ================================
           FORMULÁRIO
      ================================ -->

      <form
        class="pacote-form"
        (ngSubmit)="salvar()"
      >

        <!-- NOME -->

        <div class="campo">

          <label>
            Nome do pacote *
          </label>

          <input
            type="text"
            name="nome"
            [(ngModel)]="form.nome"
            placeholder="Ex.: Decoração romântica"
            maxlength="100"
          />

        </div>


        <!-- ACOMODAÇÃO + VALOR -->

        <div class="linha">

          <div class="campo">

            <label>
              Acomodação *
            </label>

            <select
              name="quartoId"
              [(ngModel)]="form.quartoId"
            >

              <option [ngValue]="1">
                Cabana Ypê
              </option>

              <option [ngValue]="2">
                Chalé Santorini
              </option>

            </select>

          </div>


          <div class="campo">

            <label>
              Valor *
            </label>

            <input
              type="number"
              name="valor"
              [(ngModel)]="form.valor"
              min="0.01"
              step="0.01"
              placeholder="0,00"
            />

          </div>

        </div>


        <!-- DESCRIÇÃO -->

        <div class="campo">

          <label>
            Descrição
          </label>

          <textarea
            name="descricao"
            [(ngModel)]="form.descricao"
            rows="3"
            placeholder="Descreva o pacote..."
          ></textarea>

        </div>


        <!-- ITENS -->

        <div class="campo">

          <label>
            O que está incluso?
          </label>

          <textarea
            name="itensInclusos"
            [(ngModel)]="form.itensInclusos"
            rows="5"
            placeholder="Digite um item por linha&#10;&#10;Pétalas de rosas&#10;Velas decorativas&#10;Balões&#10;Plaquinha personalizada"
          ></textarea>

          <small>
            Digite cada item em uma linha.
          </small>

        </div>


        <!-- STATUS -->

        <label class="checkbox">

          <input
            type="checkbox"
            name="ativo"
            [(ngModel)]="form.ativo"
          />

          Pacote ativo

        </label>


        <!-- ================================
             IMAGENS
        ================================ -->

        <div class="imagens-form">

          <div class="imagens-form-header">

            <div>

              <strong>
                Imagens do pacote
              </strong>

              <small>
                JPG, PNG ou WEBP — máximo 5 MB por imagem
              </small>

            </div>

            <label class="upload-btn">

              <span>
                +
              </span>

              Adicionar imagens

              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                multiple
                (change)="selecionarImagens($event)"
              />

            </label>

          </div>


          <!-- IMAGENS EXISTENTES -->

          @if (
            editando &&
            pacoteSelecionado?.imagens?.length
            ) {

            <span class="imagens-titulo">
              IMAGENS CADASTRADAS
            </span>

            <div class="imagens-grid">

              @for (
                imagem of pacoteSelecionado!.imagens;
                track imagem.id
                ) {

                <div class="imagem-existente">

                  <img
                    [src]="obterImagemUrl(imagem.url)"
                    [alt]="form.nome"
                  />

                  <button
                    type="button"
                    class="remover-imagem"
                    title="Excluir imagem"
                    (click)="excluirImagem(imagem.id)"
                  >
                    ×
                  </button>

                </div>

              }

            </div>

          }


          <!-- NOVAS IMAGENS -->

          @if (previews.length > 0) {

            <span class="imagens-titulo">
              NOVAS IMAGENS
            </span>

            <div class="imagens-grid">

              @for (
                preview of previews;
                track $index
                ) {

                <div class="imagem-nova">

                  <img
                    [src]="preview"
                    alt="Preview"
                  />

                  <button
                    type="button"
                    class="remover-imagem"
                    title="Remover"
                    (click)="removerImagemSelecionada($index)"
                  >
                    ×
                  </button>

                </div>

              }

            </div>

          }


          <!-- SEM IMAGENS -->

          @if (
            previews.length === 0 &&
            (
              !pacoteSelecionado?.imagens ||
              pacoteSelecionado!.imagens.length === 0
            )
            ) {

            <div class="sem-imagens">

              Nenhuma imagem adicionada.

            </div>

          }

        </div>


        <!-- ================================
             AÇÕES
        ================================ -->

        <div class="modal-acoes">

          <button
            type="button"
            class="btn-cancelar"
            [disabled]="salvando"
            (click)="fecharFormulario()"
          >
            Cancelar
          </button>

          <button
            type="submit"
            class="btn-salvar"
            [disabled]="salvando"
          >

            @if (salvando) {

              Salvando...

            } @else {

              {{
                editando
                  ? 'Salvar alterações'
                  : 'Cadastrar pacote'
              }}

            }

          </button>

        </div>

      </form>

    </div>

  </div>

}
